// components/WalletCard.js

import { Plus, Wallet } from "lucide-react";
import { formatMoney } from "../utils/money";

const WalletCard = ({
  title,
  balance,
  commissionRate,
  type,
  onTopUp,
  gradient,
  icon: Icon = Wallet,
}) => {
  return (
    <div
      className={`relative overflow-hidden rounded-3xl p-5 ${gradient} shadow-lg hover:shadow-xl transition-all duration-300 group cursor-pointer`}
      onClick={() => onTopUp(type)}
    >
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-20 h-20 bg-white bg-opacity-10 rounded-full -mr-10 -mt-10"></div>
      <div className="absolute bottom-0 left-0 w-12 h-12 bg-white bg-opacity-5 rounded-full -ml-6 -mb-6"></div>

      <div className="relative z-10">
        {/* Header */}
        <div className="flex items-center space-x-3 mb-4">
          <div className="w-10 h-10 bg-white bg-opacity-20 rounded-xl flex items-center justify-center backdrop-blur-sm">
            <Icon className="w-5 h-5 text-white" />
          </div>
          <div>
            <h3 className="text-white font-semibold text-base">{title}</h3>
            <p className="text-white text-opacity-70 text-xs">
              {commissionRate === 0
                ? "No Commission"
                : `${commissionRate}% Commission Added`}
            </p>
          </div>
        </div>
        {/* Balance */}
        <div>
          <p className="text-white text-opacity-70 text-xs mb-1">
            Available Balance
          </p>
          <p className="text-2xl font-bold text-white">
            GHS {formatMoney(balance)}
          </p>
        </div>
        <div className="absolute top-4 right-4">
          <button
            onClick={(e) => {
              e.stopPropagation();
              onTopUp(type);
            }}
            className="w-8 h-8 bg-white bg-opacity-20 hover:bg-opacity-30 backdrop-blur-sm rounded-lg flex items-center justify-center transition-all duration-200"
          >
            <Plus className="w-4 h-4 text-white" />
          </button>
        </div>

        <button
          onClick={() => onTopUp(type)}
          className="w-full bg-white bg-opacity-15 hover:bg-opacity-25 backdrop-blur-sm text-white text-sm font-medium py-2 px-3 rounded-lg transition-all duration-200 flex items-center justify-center space-x-1 mt-3"
        >
          <Plus className="w-3 h-3" />
          <span>Top Up</span>
        </button>
      </div>
    </div>
  );
};

export default WalletCard;
